<main class="dev-hole-screen relative min-h-screen overflow-hidden bg-zinc-950 px-3 py-3 text-zinc-100 lg:px-5">
  <div class="dev-hole-scanlines pointer-events-none absolute inset-0"></div>

  <div *ngIf="!accessChecked" class="relative z-10 mx-auto max-w-2xl rounded border border-zinc-800 bg-zinc-950 px-4 py-8 text-center font-mono text-sm font-bold text-zinc-400">Checking access.</div>

  <div *ngIf="accessChecked && !accessAllowed" class="relative z-10 mx-auto max-w-2xl rounded border border-zinc-800 bg-zinc-950 px-5 py-8 text-center shadow-sm shadow-black/30">
    <div class="mb-2 font-mono text-xs font-black uppercase tracking-normal text-zinc-500">Access</div>
    <h1 class="m-0 text-2xl font-black tracking-normal text-zinc-50">Dev Priority Hole</h1>
    <p class="m-0 mt-3 font-mono text-sm font-bold text-zinc-400">{{ accessDeniedMessage }}</p>
  </div>

  <div *ngIf="accessAllowed" class="relative z-10 mx-auto flex max-w-7xl flex-col gap-3">
    <header class="dev-hole-terminal-panel p-4">
      <div class="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
        <div class="min-w-0">
          <div class="mb-1 font-mono text-[11px] font-bold uppercase tracking-normal text-lime-300/70">internal / devs only</div>
          <h1 class="m-0 font-mono text-2xl font-black tracking-normal text-zinc-50 md:text-3xl">Dev Priority Hole</h1>
          <p class="m-0 mt-1 font-mono text-sm font-semibold text-zinc-400">Internal dev hole tracker</p>
        </div>

        <div class="flex flex-wrap items-center gap-2">
          <button type="button" class="dev-hole-button dev-hole-button--ghost" (click)="loadItems()" [disabled]="loading">
            <i class="fa-solid fa-rotate-right" [class.fa-spin]="loading"></i>
            Refresh
          </button>
          <button type="button" class="dev-hole-button dev-hole-button--primary" (click)="startCreate()">
            <i class="fa-solid fa-plus"></i>
            Expose Hole
          </button>
        </div>
      </div>

      <div class="mt-4 flex flex-wrap gap-3 font-mono text-xs text-zinc-500">
        <span>{{ activeCount }} not filled</span>
        <span>{{ visibleCount }} showing</span>
        <span>{{ totalCount }} total</span>
      </div>
    </header>

    <section class="grid grid-cols-2 gap-2 md:grid-cols-3 xl:grid-cols-6" aria-label="Dev Priority Hole summary">
      <article *ngFor="let tile of summaryTiles" [class]="tileClass(tile.tone)">
        <div class="font-mono text-[11px] font-bold uppercase tracking-normal text-zinc-500">{{ tile.label }}</div>
        <div class="mt-2 font-mono text-2xl font-black text-zinc-50">{{ tile.value }}</div>
      </article>
    </section>

    <section class="dev-hole-terminal-panel p-3">
      <form [formGroup]="filtersForm" class="grid grid-cols-1 gap-3 md:grid-cols-2 xl:grid-cols-12">
        <label class="flex flex-col gap-1 xl:col-span-3">
          <span class="dev-hole-label">Search</span>
          <input type="search" formControlName="search" class="dev-hole-control" placeholder="hole, file, api, filler">
        </label>

        <div class="flex flex-col gap-1 xl:col-span-2">
          <span class="dev-hole-label">Status</span>
          <ng-select class="dev-hole-ng-select" [items]="statusFilterOptions" [trackByFn]="selectTrackBy" bindLabel="label" bindValue="value" formControlName="status" [clearable]="false" [searchable]="false"></ng-select>
        </div>

        <div class="flex flex-col gap-1 xl:col-span-2">
          <span class="dev-hole-label">Priority</span>
          <ng-select class="dev-hole-ng-select" [items]="priorityFilterOptions" [trackByFn]="selectTrackBy" bindLabel="label" bindValue="value" formControlName="priority" [clearable]="false" [searchable]="false"></ng-select>
        </div>

        <div class="flex flex-col gap-1 xl:col-span-2">
          <span class="dev-hole-label">Kind</span>
          <ng-select class="dev-hole-ng-select" [items]="kindFilterOptions" [trackByFn]="selectTrackBy" bindLabel="label" bindValue="value" formControlName="kind" [clearable]="false" [searchable]="false"></ng-select>
        </div>

        <div class="flex flex-col gap-1 xl:col-span-2">
          <span class="dev-hole-label">Area</span>
          <ng-select class="dev-hole-ng-select" [items]="areaFilterOptions" [trackByFn]="selectTrackBy" bindLabel="label" bindValue="value" formControlName="area" [clearable]="false" [searchable]="true"></ng-select>
        </div>

        <div class="flex items-end gap-2 xl:col-span-1">
          <button type="button" class="dev-hole-icon-button" (click)="flipSortDirection()" [attr.aria-label]="sortDirectionLabel">
            <i [class]="filtersForm.get('sortDirection')?.value === 'asc' ? 'fa-solid fa-arrow-up-wide-short' : 'fa-solid fa-arrow-down-wide-short'"></i>
          </button>
        </div>

        <div class="flex flex-col gap-1 xl:col-span-3">
          <span class="dev-hole-label">Fillers</span>
          <ng-select class="dev-hole-ng-select" [items]="fillerFilterOptions" [trackByFn]="selectTrackBy" bindLabel="label" bindValue="value" formControlName="filler" [clearable]="false" [searchable]="true"></ng-select>
        </div>

        <div class="flex flex-col gap-1 xl:col-span-3">
          <span class="dev-hole-label">Sort</span>
          <ng-select class="dev-hole-ng-select" [items]="sortOptions" [trackByFn]="selectTrackBy" bindLabel="label" bindValue="value" formControlName="sortBy" [clearable]="false" [searchable]="false"></ng-select>
        </div>

        <div class="flex items-end xl:col-span-6">
          <div class="flex w-full flex-wrap items-center justify-between gap-3">
            <div class="flex flex-wrap gap-3">
              <label class="dev-hole-toggle">
                <input type="checkbox" formControlName="showArchived">
                <span>Buried</span>
              </label>
              <label class="dev-hole-toggle">
                <input type="checkbox" formControlName="showCompleted">
                <span>Filled</span>
              </label>
            </div>

            <button type="button" class="dev-hole-button dev-hole-button--ghost" (click)="clearFilters()" [disabled]="activeFilterCount === 0">
              <i class="fa-solid fa-eraser"></i>
              Clear
            </button>
          </div>
        </div>
      </form>
    </section>

    <div *ngIf="errorMessage" class="rounded border border-red-900/70 bg-red-950/40 px-4 py-3 font-mono text-sm font-bold text-red-200">
      {{ errorMessage }}
    </div>

    <div *ngIf="loading" class="dev-hole-terminal-panel px-4 py-8 text-center font-mono text-sm font-bold text-zinc-400">
      Loading.
    </div>

    <section *ngIf="!loading" class="flex flex-col gap-3" aria-label="Hole list">
      <article *ngFor="let item of filteredItems; trackBy: trackByItem" [class]="itemClass(item)">
        <div class="flex flex-col gap-3 xl:flex-row xl:items-start xl:justify-between">
          <div class="min-w-0 flex-1">
            <div class="mb-2 flex flex-wrap items-center gap-2">
              <span [class]="statusChipClass(item.status)">{{ statusLabel(item.status) }}</span>
              <span [class]="priorityBadgeClass(item.priority)">{{ priorityLabel(item.priority) }}</span>
              <span class="dev-hole-chip dev-hole-chip--kind">{{ kindLabel(item.kind) }}</span>
              <span *ngIf="item.area" class="dev-hole-chip dev-hole-chip--area">{{ item.area }}</span>
              <span *ngIf="item.archived" class="dev-hole-chip dev-hole-chip--archived">Buried</span>
            </div>

            <h2 class="m-0 break-words font-mono text-lg font-black tracking-normal text-zinc-50">{{ item.title }}</h2>
            <p *ngIf="item.description" class="m-0 mt-2 whitespace-pre-wrap break-words text-sm font-medium leading-6 text-zinc-300">{{ item.description }}</p>

            <div class="mt-3 flex flex-wrap items-center gap-2 font-mono text-xs font-bold text-zinc-500">
              <span>updated {{ formatDate(item.updated_at) }}</span>
              <span *ngIf="item.completed_at">filled {{ formatDate(item.completed_at) }}</span>
            </div>

            <div class="mt-3 grid grid-cols-1 gap-3 lg:grid-cols-2" *ngIf="item.file_refs.length || hasDevDetails(item)">
              <div *ngIf="item.file_refs.length" class="dev-hole-card-strip">
                <div class="dev-hole-strip-label">Files / APIs / Helpers</div>
                <div class="mt-2 flex flex-wrap gap-2">
                  <code *ngFor="let fileRef of item.file_refs; trackBy: trackByString" class="dev-hole-file-chip">{{ fileRef }}</code>
                </div>
              </div>

              <div *ngIf="hasDevDetails(item)" class="dev-hole-card-strip">
                <div class="dev-hole-strip-label">Dev Notes</div>
                <dl class="m-0 mt-2 grid grid-cols-1 gap-2 text-sm lg:grid-cols-2">
                  <div *ngIf="item.trigger_steps">
                    <dt class="dev-hole-mini-label">Trigger</dt>
                    <dd class="m-0 whitespace-pre-wrap text-zinc-300">{{ item.trigger_steps }}</dd>
                  </div>
                  <div *ngIf="item.done_when">
                    <dt class="dev-hole-mini-label">Done when</dt>
                    <dd class="m-0 whitespace-pre-wrap text-zinc-300">{{ item.done_when }}</dd>
                  </div>
                  <div *ngIf="item.expected_result">
                    <dt class="dev-hole-mini-label">Expected</dt>
                    <dd class="m-0 whitespace-pre-wrap text-zinc-300">{{ item.expected_result }}</dd>
                  </div>
                  <div *ngIf="item.actual_result">
                    <dt class="dev-hole-mini-label">Actual</dt>
                    <dd class="m-0 whitespace-pre-wrap text-zinc-300">{{ item.actual_result }}</dd>
                  </div>
                </dl>
              </div>
            </div>

            <div class="mt-3 flex flex-wrap items-center gap-2">
              <span class="font-mono text-[11px] font-bold uppercase tracking-normal text-zinc-600">Fillers</span>
              <span *ngIf="!item.fillers.length" class="rounded border border-zinc-800 bg-zinc-950 px-2 py-1 font-mono text-[11px] font-bold text-zinc-500">No fillers</span>
              <span *ngFor="let filler of item.fillers; trackBy: trackByFiller" class="rounded border border-zinc-700 bg-zinc-950 px-2 py-1 font-mono text-[11px] font-bold text-zinc-400">
                {{ filler.email }}
              </span>
            </div>

            <div *ngIf="item.tags.length" class="mt-3 flex flex-wrap gap-2">
              <span *ngFor="let tag of item.tags; trackBy: trackByString" class="rounded border border-zinc-700 bg-zinc-950 px-2 py-1 font-mono text-[11px] font-bold text-zinc-400">{{ tag }}</span>
            </div>
          </div>

          <div class="flex shrink-0 flex-wrap gap-2 xl:max-w-[330px] xl:justify-end">
            <button *ngIf="!isFilledByCurrentUser(item)" type="button" class="dev-hole-button dev-hole-button--compact dev-hole-button--primary" (click)="startFilling(item)" [disabled]="busyUuid === item.uuid">
              Start Filling
            </button>
            <button *ngIf="isFilledByCurrentUser(item)" type="button" class="dev-hole-button dev-hole-button--compact dev-hole-button--ghost" (click)="stopFilling(item)" [disabled]="busyUuid === item.uuid">
              Stop Filling
            </button>
            <button *ngIf="item.status !== 'done'" type="button" class="dev-hole-button dev-hole-button--compact dev-hole-button--primary" (click)="markFilled(item)" [disabled]="busyUuid === item.uuid">
              Mark Filled
            </button>
            <button *ngIf="item.status === 'done'" type="button" class="dev-hole-button dev-hole-button--compact dev-hole-button--ghost" (click)="reopen(item)" [disabled]="busyUuid === item.uuid">
              Reopen
            </button>
            <button type="button" class="dev-hole-button dev-hole-button--compact dev-hole-button--ghost" (click)="startEdit(item)">Edit Hole</button>
            <button type="button" class="dev-hole-button dev-hole-button--compact dev-hole-button--ghost" (click)="startAddNote(item)">
              Note
            </button>
            <button type="button" class="dev-hole-button dev-hole-button--compact dev-hole-button--ghost" (click)="toggleExpanded(item)">
              {{ expandedUuid === item.uuid ? 'Less' : 'More' }} ({{ item.notes.length }})
            </button>
            <button type="button" class="dev-hole-button dev-hole-button--compact dev-hole-button--danger" (click)="askBury(item)" [disabled]="busyUuid === item.uuid">
              {{ item.archived ? 'Dig Up' : 'Bury' }}
            </button>
          </div>
        </div>

        <div *ngIf="pendingBuryUuid === item.uuid" class="mt-3 flex flex-col gap-3 rounded border border-amber-800 bg-amber-950/30 p-3 font-mono text-sm font-bold text-amber-100 md:flex-row md:items-center md:justify-between">
          <span>Bury this hole?</span>
          <div class="flex gap-2">
            <button type="button" class="dev-hole-button dev-hole-button--compact dev-hole-button--ghost" (click)="cancelBury()">Cancel</button>
            <button type="button" class="dev-hole-button dev-hole-button--compact dev-hole-button--danger" (click)="confirmBury(item)">Bury</button>
          </div>
        </div>

        <div *ngIf="expandedUuid === item.uuid || activeNoteItemUuid === item.uuid" class="mt-4 border-t border-zinc-800 pt-4">
          <div class="mb-3 flex items-center justify-between gap-3">
            <h3 class="m-0 font-mono text-xs font-black uppercase tracking-normal text-zinc-400">Notes</h3>
            <button type="button" class="dev-hole-button dev-hole-button--compact dev-hole-button--ghost" (click)="startAddNote(item)">Add Note</button>
          </div>

          <div *ngIf="!item.notes.length && activeNoteItemUuid !== item.uuid" class="rounded border border-dashed border-zinc-800 px-3 py-4 font-mono text-sm font-bold text-zinc-500">
            No notes.
          </div>

          <div class="flex flex-col gap-2">
            <div *ngFor="let note of item.notes; trackBy: trackByNote" class="rounded border border-zinc-800 bg-zinc-950/70 p-3">
              <ng-container *ngIf="editingNoteUuid === note.uuid; else noteDisplay">
                <form [formGroup]="noteEditForm" (ngSubmit)="saveNoteEdit(note)" class="flex flex-col gap-2">
                  <textarea formControlName="body" rows="3" class="dev-hole-control min-h-[76px]"></textarea>
                  <div class="flex justify-end gap-2">
                    <button type="button" class="dev-hole-button dev-hole-button--compact dev-hole-button--ghost" (click)="cancelNoteEdit()">Cancel</button>
                    <button type="submit" class="dev-hole-button dev-hole-button--compact dev-hole-button--primary" [disabled]="noteEditForm.invalid || busyUuid === note.uuid">Save</button>
                  </div>
                </form>
              </ng-container>

              <ng-template #noteDisplay>
                <p class="m-0 whitespace-pre-wrap break-words text-sm font-medium leading-6 text-zinc-300">{{ note.body }}</p>
                <div class="mt-2 flex flex-wrap items-center justify-between gap-2 font-mono text-[11px] font-bold text-zinc-600">
                  <span>{{ note.updated_at ? 'edited ' + formatDate(note.updated_at) : 'added ' + formatDate(note.created_at) }}</span>
                  <button type="button" class="text-zinc-400 underline decoration-zinc-700 underline-offset-4 hover:text-zinc-100" (click)="startEditNote(item, note)">Edit</button>
                </div>
              </ng-template>
            </div>
          </div>

          <form *ngIf="activeNoteItemUuid === item.uuid" [formGroup]="noteForm" (ngSubmit)="addNote(item)" class="mt-3 flex flex-col gap-2 rounded border border-zinc-800 bg-zinc-950/70 p-3">
            <textarea formControlName="body" rows="3" class="dev-hole-control min-h-[76px]" placeholder="note"></textarea>
            <div class="flex justify-end gap-2">
              <button type="button" class="dev-hole-button dev-hole-button--compact dev-hole-button--ghost" (click)="cancelAddNote()">Cancel</button>
              <button type="submit" class="dev-hole-button dev-hole-button--compact dev-hole-button--primary" [disabled]="noteForm.invalid || busyUuid === item.uuid">Add Note</button>
            </div>
          </form>
        </div>
      </article>

      <div *ngIf="filteredItems.length === 0" class="dev-hole-terminal-panel border-dashed px-4 py-10 text-center font-mono text-sm font-bold text-zinc-500">
        {{ emptyMessage }}
      </div>
    </section>
  </div>

  <div *ngIf="editorOpen" class="dev-hole-modal-backdrop fixed inset-0 z-50 flex items-start justify-center overflow-y-auto px-3 py-4 md:py-8" (click)="cancelEdit()">
    <section class="dev-hole-modal-panel w-full max-w-5xl" (click)="$event.stopPropagation()" role="dialog" aria-modal="true" [attr.aria-label]="editorTitle">
      <header class="flex items-start justify-between gap-3 border-b border-zinc-800 px-4 py-3 md:px-5">
        <div class="min-w-0">
          <div class="font-mono text-[11px] font-bold uppercase tracking-normal text-lime-300/70">DPH input</div>
          <h2 class="m-0 mt-1 font-mono text-xl font-black tracking-normal text-zinc-50">{{ editorTitle }}</h2>
        </div>
        <button type="button" class="dev-hole-icon-button" (click)="cancelEdit()" aria-label="Close editor">
          <i class="fa-solid fa-xmark"></i>
        </button>
      </header>

      <form [formGroup]="itemForm" (ngSubmit)="saveItem()" class="grid grid-cols-1 gap-y-3 gap-x-4 p-4 md:grid-cols-12 md:p-5">
        <label class="flex flex-col gap-1 md:col-span-12">
          <span class="dev-hole-label">Hole</span>
          <input type="text" formControlName="title" class="dev-hole-control" placeholder="brief, useful">
          <span *ngIf="itemForm.get('title')?.touched && itemForm.get('title')?.invalid" class="font-mono text-xs text-red-300">Hole is required.</span>
        </label>

        <div class="flex flex-col gap-1 md:col-span-3">
          <span class="dev-hole-label">Kind</span>
          <ng-select class="dev-hole-ng-select" [items]="kindOptions" [trackByFn]="selectTrackBy" bindLabel="label" bindValue="value" formControlName="kind" [clearable]="false" [searchable]="false" appendTo=".dev-hole-modal-panel"></ng-select>
        </div>

        <div class="flex flex-col gap-1 md:col-span-5">
          <span class="dev-hole-label">Area</span>
          <ng-select
            class="dev-hole-ng-select"
            [items]="areaSelectOptions" [trackByFn]="selectTrackBy"
            appendTo=".dev-hole-modal-panel"
            bindLabel="label"
            bindValue="value"
            formControlName="area"
            [addTag]="addPlainTextOption"
            [clearable]="true"
            [searchable]="true"
            [searchFn]="textOptionSearch"
            [selectOnTab]="true"
            addTagText="Add"
            placeholder="type or choose area"
          ></ng-select>
        </div>

        <div class="flex flex-col gap-1 md:col-span-2">
          <span class="dev-hole-label">Priority</span>
          <ng-select class="dev-hole-ng-select" [items]="priorityOptions" [trackByFn]="selectTrackBy" bindLabel="label" bindValue="value" formControlName="priority" [clearable]="false" [searchable]="false" appendTo=".dev-hole-modal-panel"></ng-select>
        </div>

        <div class="flex flex-col gap-1 md:col-span-2">
          <span class="dev-hole-label">Status</span>
          <ng-select class="dev-hole-ng-select" [items]="statusOptions" [trackByFn]="selectTrackBy" bindLabel="label" bindValue="value" formControlName="status" [clearable]="false" [searchable]="false" appendTo=".dev-hole-modal-panel"></ng-select>
        </div>

        <div class="flex flex-col gap-1 md:col-span-12">
          <span class="dev-hole-label">Tags</span>
          <ng-select
            class="dev-hole-ng-select"
            [items]="tagSelectOptions" [trackByFn]="selectTrackBy"
            appendTo=".dev-hole-modal-panel"
            bindLabel="label"
            bindValue="value"
            formControlName="tags"
            [multiple]="true"
            [addTag]="addPlainTextOption"
            [clearable]="true"
            [searchable]="true"
            [searchFn]="textOptionSearch"
            [closeOnSelect]="false"
            [selectOnTab]="true"
            addTagText="Add"
            placeholder="type or choose tags"
          ></ng-select>
        </div>

        <div class="flex flex-col gap-1 md:col-span-12">
          <div class="flex flex-wrap items-center justify-between gap-2">
            <span class="dev-hole-label">Files / APIs / Helpers</span>
            <button type="button" class="dev-hole-button dev-hole-button--compact dev-hole-button--ghost" (click)="refreshReferenceOptions()" [disabled]="refreshingReferences">
              <i class="fa-solid fa-rotate-right" [class.fa-spin]="refreshingReferences"></i>
              Refresh Files
            </button>
          </div>
          <ng-select class="dev-hole-ng-select dev-hole-ng-select--multi" appendTo=".dev-hole-modal-panel" [items]="fileRefOptions" [trackByFn]="selectTrackBy" bindLabel="label" bindValue="path" formControlName="fileRefs" [multiple]="true" [addTag]="addFileReferenceTag" [clearable]="true" [searchable]="true" [searchFn]="fileReferenceSearch" placeholder="search components, services, or api php files">
            <ng-template ng-label-tmp let-item="item">
              {{ item.path }}
            </ng-template>
            <ng-template ng-option-tmp let-item="item">
              <div class="flex min-w-0 flex-col gap-1">
                <span class="truncate font-bold text-zinc-100">{{ item.label }}</span>
                <span class="truncate text-[11px] font-bold text-zinc-500">{{ item.group }} / {{ item.path }}</span>
              </div>
            </ng-template>
          </ng-select>
        </div>

        <label class="flex flex-col gap-1 md:col-span-12">
          <span class="dev-hole-label">Details</span>
          <textarea formControlName="description" rows="4" class="dev-hole-control min-h-[96px]" placeholder="what is missing, broken, unfinished, or unclear"></textarea>
        </label>

        <label class="flex flex-col gap-1 md:col-span-6">
          <span class="dev-hole-label">Trigger / Path</span>
          <textarea formControlName="triggerSteps" rows="3" class="dev-hole-control min-h-[84px]" placeholder="where to see it, how to hit it, or what path leads there"></textarea>
        </label>

        <label class="flex flex-col gap-1 md:col-span-6">
          <span class="dev-hole-label">Done When</span>
          <textarea formControlName="doneWhen" rows="3" class="dev-hole-control min-h-[84px]" placeholder="what makes this hole filled?"></textarea>
        </label>

        <label class="flex flex-col gap-1 md:col-span-6">
          <span class="dev-hole-label">Expected</span>
          <textarea formControlName="expectedResult" rows="3" class="dev-hole-control min-h-[84px]" placeholder="what should happen"></textarea>
        </label>

        <label class="flex flex-col gap-1 md:col-span-6">
          <span class="dev-hole-label">Actual</span>
          <textarea formControlName="actualResult" rows="3" class="dev-hole-control min-h-[84px]" placeholder="what currently happens"></textarea>
        </label>

        <footer class="flex flex-wrap items-center justify-end gap-3 border-t border-zinc-800 pt-4 md:col-span-12">
          <div class="flex flex-wrap justify-end gap-2">
            <button type="button" class="dev-hole-button dev-hole-button--ghost" (click)="cancelEdit()">Cancel</button>
            <button type="submit" class="dev-hole-button dev-hole-button--primary" [disabled]="saving || itemForm.invalid">
              <i class="fa-solid fa-floppy-disk"></i>
              Save
            </button>
          </div>
        </footer>
      </form>
    </section>
  </div>
</main>